import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Collapsible,
  CollapsiblePanel,
  CollapsibleContent,
} from '@americanexpress/dls-react';
/* eslint-disable  import/no-cycle -- need */
import { constructChildStructure } from '../ChildConstructor';
import { getIcon } from './Icons';
import { parseHtml } from '../../utils/util';

/**
 * component return DLS Accordion component
 * @param {*} props
 */
const DynamicDlsAccordion = ({
  cssProperties,
  nodeLabel,
  defaultOpenIds = [],
  nodeId,
  childElements,
  accordionDynamicProperties,
  props,
  nodeIcon = '',
}) => {
  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  });
  /* eslint-enable  import/no-cycle -- need */
  return (
    <div className={cssProperties.style}>
      <Collapsible
        theme={{
          border: '0.0625rem solid #ecedee',
        }}
        defaultOpen={defaultOpenIds}
        style={accordionDynamicProperties && accordionDynamicProperties.isTableScrollable
          ? { display: 'block', 'max-height': `${accordionDynamicProperties.maxHeight}`, 'overflow-y': 'scroll' }
          : { 'max-height': 'auto' }}
      >
        <CollapsiblePanel
          id={nodeId}
          icon={getIcon(nodeIcon)}
          theme={{
            color: '0.0625rem solid #001754',
            fontWeight: '600',
          }}
        >
          {parseHtml(nodeLabel)}
        </CollapsiblePanel>
        <CollapsibleContent
          labelledBy={nodeId}
          style={accordionDynamicProperties && accordionDynamicProperties.isContentScrollable && { overflowY: 'scroll' }}
        >
          {
            constructChildStructure(childElements, props, nodeId)
          }
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

DynamicDlsAccordion.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  defaultOpenIds: PropTypes.arrayOf(PropTypes.shape),
  nodeLabel: PropTypes.string,
  nodeId: PropTypes.string,
  childElements: PropTypes.objectOf(PropTypes.shape),
  accordionDynamicProperties: PropTypes.objectOf(PropTypes.shape),
  props: PropTypes.objectOf(PropTypes.shape),
  nodeIcon: PropTypes.string,
};

export default DynamicDlsAccordion;
